import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const FinalizeQuoteTaskAttemptSchema = z.object({
  type: z.literal(TaskType.FINALIZE_QUOTE),
  bidQuoteId: z.string().optional(),
  quoteVersionId: z.string().optional(),
  sowChange: z.string(),
});
